export const SOCIAL = {
  facebook: process.env.REACT_APP_FACEBOOK || 'https://www.facebook.com/wijdansufism',
  twitter: process.env.REACT_APP_TWITTER || 'https://x.com/wijdan29721641',
  instagram: process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/wijdansufism',
  youtube: process.env.REACT_APP_YOUTUBE || 'https://www.youtube.com/channel/UC5KqoC3UPNvF5LjPQL3nC2A',
};

export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP || '923370429595';
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=Assalam%20o%20Alaikum`;
export const WHATSAPP_DISPLAY = '0337-0429595';

export const CATEGORIES = ['Sufism', 'Literature', 'Art', 'Culture'];

export const COLORS = {
  saffron: '#E8851A',
  saffronLight: '#F5A623',
  saffronDark: '#C96F0C',
  cream: '#FFF9F0',
  warmWhite: '#FFFCF7',
  dark: '#2C1810',
  brown: '#5C3A1E',
  gold: '#D4A847',
  softOrange: '#FDE8CD',
};
